var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArticles(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 61,
    height: 61,
    viewBox: "0 0 61 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1474_41)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.9286 0H0V53.4781C0 57.3926 3.18432 60.5769 7.09886 60.5769H53.4781H53.479C57.3926 60.5769 60.5769 57.3926 60.5769 53.4781V28.5137H49.9286V0ZM7.09886 57.0275C5.14159 57.0275 3.54943 55.4353 3.54943 53.4781V3.54943H46.3792V53.4781C46.3792 54.7707 46.7281 55.9825 47.334 57.0275H7.09886ZM57.0275 32.0632V53.4781C57.0275 55.4353 55.4358 57.0275 53.4781 57.0275C51.5208 57.0275 49.9286 55.4353 49.9286 53.4781V32.0632H57.0275Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09863 21.4149H42.8296V7.09888H7.09863V21.4149ZM10.6481 10.6483H39.2801V17.8655H10.6481V10.6483Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09863 24.9644H24.9641V28.5138H7.09863V24.9644Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 24.9644H42.8297V28.5138H28.5137V24.9644Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09863 32.0632H24.9641V35.6127H7.09863V32.0632Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 32.0632H42.8297V35.6127H28.5137V32.0632Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09863 39.1621H24.9641V42.7115H7.09863V39.1621Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.09863 46.261H24.9641V49.8104H7.09863V46.261Z",
    fill: "#1A133D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 49.8104H42.8297V39.1621H28.5137V49.8104ZM32.0631 42.7115H39.2803V46.261H32.0631V42.7115Z",
    fill: "#1A133D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1474_41"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60.5769,
    height: 60.5769,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticles);
export default __webpack_public_path__ + "static/media/Articles.f97dfb67f0a4f54c87c178fcd9b61f4e.svg";
export { ForwardRef as ReactComponent };